import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ExecutiveSearchBenefit from "@/components/Shared/ExecutiveSearchBenefit";
import ReadyToApply from "@/components/Shared/ReadyToApply";
import ServicePageBanner from "@/components/ServicePage/ServicePageBanner";
import ServicePageSwiper from "@/components/ServicePage/ServicePageSwiper";
import Solution from "@/components/Shared/Solution";
import SubmitForm from "@/components/Shared/SubmitForm";
import SEO from "@/components/SEO";
import localizePath from "@/functions/localizePath";
import vector from "@/assets/service/vector-service.png";

export default function ExecutiveSearchPage({ locale = "en" }) {
  return (
    <>
      <SEO
        path={localizePath("/executive-search", locale)}
        title="Executive Search | Lawrence Harvey"
        description="Our most comprehensive search solution."
      />
      <main className="bg-white h-full">
        <ServicePageBanner title="Executive Search" path="executive-search" />
        {/* <div className="container pt-10">
          <h2 className="text-4xl sm:text-[40px] font-normal  text-purple leading-[50px]">
            <CustomSourceFlowText
              title="Lawrence Harvey stands out for its commitment to identifying and securing executive-level professionals who can foster innovation and navigate the complexities of the tech market."
              path="dynamic1.executive-search.headline"
              locale={locale}
            />
          </h2>
          <h2 className="text-4xl sm:text-[40px] pt-10 font-normal  text-purple leading-[50px]">
            <CustomSourceFlowText
              title="By leveraging a global network and an in-depth understanding of the industry, Lawrence Harvey provides tailored executive search services, guaranteeing that clients connect with top-tier leaders poised to propel their organisations towards future success."
              path="dynamic1.executive-search.headline2"
              locale={locale}
            />
          </h2>
        </div> */}
        <ExecutiveSearchBenefit
          title="What are the benefits of a Executive Search?"
          path="executive-search"
        />
        <div className="container -mt-10 sm:-mt-20 pb-[128px]">
          <ReadyToApply
            bgColor="bg-blue"
            link="true"
            path="service"
            button1Link={localizePath("/vacancies", locale)}
          />
        </div>
        <div className="bg-purple">
          <ServicePageSwiper />
          <div className="relative">
            <img
              src={vector ?? ""}
              alt="vector"
              className="absolute right-0 bottom-20"
            />
            <Solution
              solution="executive"
              color="text-white"
              path="executive-search"
            />
            <div>
              <SubmitForm />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
